// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const pipedreamClient = createTypedClient();
export const createPipedreamClient = (config) => createTypedClient(config);
